import { Helmet } from "react-helmet";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import dashboardImg from "../assets/dashboard_blurred.png";
import chartImg from "../assets/chart_blurred.png";
import adminImg from "../assets/admin_blurred.png";
import ticketImg from "../assets/ticket_blurred.png";
import storeManagerImg from "../assets/Storemanager.png";

const LandingPage = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>PBIS Rewards System for Schools | PBIS Portal</title>
        <meta
          name="description"
          content="PBIS Portal helps schools track positive behavior, reward students, and manage PBIS systems with simple, easy-to-use tools."
        />
        <link rel="canonical" href="https://pbisportal.com/" />
      </Helmet>
  
      <div
      style={{
        fontFamily: "'Segoe UI', sans-serif",
        backgroundColor: "#f8fafc",
        color: "#1e293b",
        minHeight: "100vh",
      }}
    >
      {/* Header */}
      <header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "1rem 2rem",
          backgroundColor: "#1e3a8a",
          color: "white",
          position: "sticky",
          top: 0,
          zIndex: 1000,
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.12)",
        }}
      >
        <Link
          to="/"
          style={{
            fontSize: "1.8rem",
            fontWeight: "700",
            cursor: "pointer",
            letterSpacing: "-0.02em",
            color: "inherit",
            textDecoration: "none",
          }}
        >
          🎯 PBIS Portal
        </Link>

        <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
  <Link
    to="/about"
    style={{
      background: "transparent",
      color: "white",
      border: "none",
      fontSize: "1rem",
      cursor: "pointer",
      fontWeight: "500",
    }}
  >
    About
  </Link>

  {/* NEW BUTTON */}
  <Link
    to="/features"
    style={{
      background: "transparent",
      color: "white",
      border: "none",
      fontSize: "1rem",
      cursor: "pointer",
      fontWeight: "500",
    }}
  >
    Features
  </Link>
  <Link
  to="/what-is-pbis"
  style={{
    background: "transparent",
    color: "white",
    border: "none",
    fontSize: "1rem",
    cursor: "pointer",
    fontWeight: "500",
  }}
>
  What is PBIS?
</Link>
<Link
  to="/contact"
  style={{
    background: "transparent",
    color: "white",
    border: "none",
    fontSize: "1rem",
    cursor: "pointer",
    fontWeight: "500",
  }}
>
  Contact
</Link>
<Link
  to="/login"
  style={{
    backgroundColor: "#2563eb",
    color: "#fff",
    border: "none",
    padding: "0.65rem 1.2rem",
    fontSize: "1rem",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "600",
  }}
  >
    Log In
  </Link>
</div>
      </header>

      {/* Hero */}
      <main
        style={{
          textAlign: "center",
          padding: "5rem 2rem 4rem",
          background: "linear-gradient(135deg, #e0f2fe 0%, #ecfeff 100%)",
        }}
      >
        <div style={{ maxWidth: "950px", margin: "0 auto" }}>
          <h1
            style={{
              fontSize: "3rem",
              fontWeight: "800",
              lineHeight: "1.15",
              marginBottom: "1rem",
              color: "#1e293b",
            }}
          >
            PBIS Portal – Positive Behavior Recognition and Reward System for Schools
          </h1>

          <h2
            style={{
              fontSize: "1.5rem",
              fontWeight: "600",
              color: "#334155",
              marginBottom: "1.25rem",
            }}
          >
            Track Success. Reward Growth. Support Every Student.
          </h2>

          <p
            style={{
              fontSize: "1.15rem",
              maxWidth: "760px",
              margin: "0 auto 2rem",
              color: "#475569",
              lineHeight: "1.7",
            }}
          >
            PBIS Portal helps schools recognize positive student behavior, reward positive choices, manage school stores, and support school-wide PBIS systems with simple digital tools for teachers, staff, and administrators.
          </p>
          <div
  style={{
    margin: "2rem auto 1.5rem",
    maxWidth: "700px",
    textAlign: "center",
  }}
>
  <div
    style={{
      display: "inline-block",
      backgroundColor: "#dcfce7",
      color: "#166534",
      padding: "0.35rem 0.7rem",
      borderRadius: "999px",
      fontSize: "0.8rem",
      fontWeight: 700,
      letterSpacing: "0.04em",
      marginBottom: "0.75rem",
    }}
  >
    SIMPLE ANNUAL PRICING
  </div>

  <div
    style={{
      fontSize: "1.9rem",
      fontWeight: "800",
      color: "#1e293b",
      marginBottom: "0.35rem",
    }}
  >
    $150 per Year
  </div>

  <div
    style={{
      fontSize: "1.05rem",
      color: "#475569",
    }}
  >
    One annual plan for your entire school.
  </div>
</div>

          <div
            style={{
              display: "flex",
              gap: "1rem",
              justifyContent: "center",
              flexWrap: "wrap",
              marginBottom: "2.25rem",
            }}
          >
            <button
              onClick={() => navigate("/signup")}
              style={{
                backgroundColor: "#4f46e5",
                color: "white",
                fontSize: "1.05rem",
                padding: "0.85rem 2rem",
                border: "none",
                borderRadius: "8px",
                fontWeight: "700",
                boxShadow: "0 6px 18px rgba(79, 70, 229, 0.28)",
                cursor: "pointer",
              }}
            >
              Create Your School Account
            </button>

            <button
              onClick={() => navigate("/demo")}
              style={{
                backgroundColor: "#10b981",
                color: "white",
                fontSize: "1.05rem",
                padding: "0.85rem 2rem",
                border: "none",
                borderRadius: "8px",
                fontWeight: "700",
                boxShadow: "0 6px 18px rgba(16, 185, 129, 0.28)",
                cursor: "pointer",
              }}
            >
              View Demo
            </button>
          </div>

          <div
            style={{
              maxWidth: "820px",
              margin: "0 auto",
              backgroundColor: "rgba(255,255,255,0.65)",
              border: "1px solid rgba(148, 163, 184, 0.2)",
              borderRadius: "14px",
              padding: "1rem 1.25rem",
            }}
          >
            <p
              style={{
                margin: 0,
                fontSize: "1rem",
                color: "#475569",
                lineHeight: "1.6",
              }}
            >
              Built for PBIS coordinators, teachers, administrators, and K–12 schools looking for a simple way to recognize positive behavior, reward students, and build a strong school culture.
            </p>
          </div>
        </div>
      </main>

      {/* Feature Highlights */}
      <section
        style={{
          padding: "4rem 2rem 2rem",
          backgroundColor: "#ffffff",
        }}
      >
        <div style={{ maxWidth: "1100px", margin: "0 auto" }}>
          <h2
            style={{
              textAlign: "center",
              fontSize: "2rem",
              marginBottom: "0.75rem",
              color: "#1e293b",
            }}
          >
            Tools Built for Everyday PBIS Work
          </h2>
          <p
            style={{
              textAlign: "center",
              color: "#64748b",
              maxWidth: "760px",
              margin: "0 auto 2.5rem",
              lineHeight: "1.7",
            }}
          >
            PBIS Portal gives schools one place to recognize positive behavior, manage ticket rewards, support student incentives, and simplify PBIS systems without juggling spreadsheets or paper forms.
          </p>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "2rem",
              flexWrap: "wrap",
            }}
          >
            <Feature
              icon="📊"
             title="Recognize Positive Behavior"
desc="Track PBIS tickets and celebrate positive student actions with simple tools designed for everyday school use."
            />
            <Feature
              icon="🎁"
              title="Reward Growth"
              desc="Reinforce positive behavior with tickets, student rewards, and a customizable PBIS school store."
            />
            <Feature
              icon="⚙️"
              title="Admin Tools"
              desc="Manage students, staff, advisories, and PBIS settings with an easy-to-use admin dashboard."
            />
          </div>
        </div>
      </section>

      {/* Screenshot Gallery */}
      <section
        style={{
          padding: "2rem 2rem 1rem",
          backgroundColor: "#f8fafc",
        }}
      >
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <h2
            style={{
              textAlign: "center",
              fontSize: "1.9rem",
              marginBottom: "0.75rem",
              color: "#1e293b",
            }}
          >
            See PBIS Portal in Action
          </h2>
          <p
            style={{
              textAlign: "center",
              color: "#64748b",
              maxWidth: "760px",
              margin: "0 auto 2rem",
              lineHeight: "1.7",
            }}
          >
            From ticket entry and dashboards to school store management and admin tools, PBIS Portal helps schools recognize positive behavior and keep PBIS systems organized and easy to use.
          </p>

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: "1.5rem",
            }}
          >
            {[dashboardImg, chartImg, adminImg, ticketImg, storeManagerImg].map(
              (imgSrc, idx) => (
                <img
                  key={idx}
                  src={imgSrc}
                  alt={`PBIS Portal screenshot ${idx + 1}`}
                  style={{
                    width: "300px",
                    height: "180px",
                    objectFit: "cover",
                    borderRadius: "12px",
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    boxShadow: "0 4px 14px rgba(0,0,0,0.1)",
                    backgroundColor: "#fff",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "scale(1.03)";
                    e.currentTarget.style.boxShadow =
                      "0 8px 22px rgba(0,0,0,0.14)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                    e.currentTarget.style.boxShadow =
                      "0 4px 14px rgba(0,0,0,0.1)";
                  }}
                />
              )
            )}
          </div>
        </div>
      </section>

      {/* Testimonial */}
      <section
        style={{
          padding: "3rem 2rem 4rem",
          backgroundColor: "#f8fafc",
        }}
      >
        <div
          style={{
            backgroundColor: "#fef9c3",
            padding: "2rem",
            textAlign: "center",
            fontSize: "1.1rem",
            color: "#6d28d9",
            maxWidth: "850px",
            margin: "0 auto",
            borderRadius: "14px",
            lineHeight: "1.7",
            boxShadow: "0 6px 16px rgba(0,0,0,0.06)",
          }}
        >
          “It used to take us hours to enter tickets and track data, but with
          PBIS Portal, it's all done instantly!”
          <br />
          “The reward store feature is my favorite!”
          <div style={{ marginTop: "0.75rem", fontWeight: "700" }}>
            
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer
        style={{
          backgroundColor: "#1e3a8a",
          color: "white",
          padding: "2rem",
          marginTop: "1rem",
        }}
      >
        <div
          style={{
            maxWidth: "1100px",
            margin: "0 auto",
            display: "flex",
            justifyContent: "space-between",
            gap: "2rem",
            flexWrap: "wrap",
          }}
        >
          <div style={{ maxWidth: "520px" }}>
            <h3 style={{ marginTop: 0, marginBottom: "0.75rem" }}>
              🎯 PBIS Portal
            </h3>
            <p style={{ margin: 0, lineHeight: "1.7", color: "#dbeafe" }}>
            PBIS Portal is a PBIS positive behavior recognition and student reward system designed to help schools celebrate student success, motivate growth, and build a positive school culture.
            </p>
          </div>

          <div>
            <h4 style={{ marginTop: 0, marginBottom: "0.75rem" }}>Quick Links</h4>
            <div style={{ display: "grid", gap: "0.5rem" }}>
              <Link to="/" style={footerLinkStyle}>
                Home
              </Link>
              <Link to="/about" style={footerLinkStyle}>
                About
              </Link>
              <Link to="/features" style={footerLinkStyle}>
                Features
              </Link>
              <Link to="/login" style={footerLinkStyle}>
                Log In
              </Link>
              <Link to="/signup" style={footerLinkStyle}>
                Get Started
              </Link>
            </div>
          </div>
        </div>

        <div
          style={{
            maxWidth: "1100px",
            margin: "1.5rem auto 0",
            paddingTop: "1rem",
            borderTop: "1px solid rgba(255,255,255,0.2)",
            color: "#bfdbfe",
            fontSize: "0.95rem",
          }}
        >
          © 2026 PBIS Portal
        </div>
      </footer>
      </div>
</>
);
};

const Feature = ({ icon, title, desc }) => (
  <div
    style={{
      maxWidth: "300px",
      textAlign: "center",
      backgroundColor: "#f8fafc",
      padding: "1.5rem 1.25rem",
      borderRadius: "14px",
      boxShadow: "0 4px 14px rgba(0,0,0,0.06)",
    }}
  >
    <div style={{ fontSize: "2.1rem", marginBottom: "0.5rem" }}>{icon}</div>
    <h3 style={{ fontSize: "1.2rem", margin: "0.5rem 0", color: "#1e293b" }}>
      {title}
    </h3>
    <p style={{ fontSize: "0.98rem", color: "#475569", lineHeight: "1.6" }}>
      {desc}
    </p>
  </div>
);

const footerLinkStyle = {
  background: "transparent",
  color: "#dbeafe",
  border: "none",
  padding: 0,
  textAlign: "left",
  cursor: "pointer",
  textDecoration: "none",
  fontSize: "0.98rem",
};

export default LandingPage;
